import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// UTMify Pixel Script
;
(window as any).pixelId = '69a332458bc6323e9ed1a0f3';
const pixelScript = document.createElement('script');
pixelScript.setAttribute('async', '');
pixelScript.setAttribute('defer', '');
pixelScript.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
document.head.appendChild(pixelScript);
// UTMify Latest Script
const latestScript = document.createElement('script');
latestScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
latestScript.setAttribute('data-utmify-prevent-xcod-sck', '');
latestScript.setAttribute('data-utmify-prevent-subids', '');
latestScript.async = true;
latestScript.defer = true;
document.head.appendChild(latestScript);
render(<App data-id="element-436" />, document.getElementById('root'));